export default __webpack_public_path__ + "1312d2a8d01390a3dc775d37543ff27c.png";